import { formOptions } from "@tanstack/react-form";

import { OfferType } from "~/lib/schemas/db-enums";
import type { OfferFormData } from "~/lib/schemas/offer";

/**
 * Representative empty value used only for tanstack-form type inference in
 * `withForm` sections. Real values come from `initialData` at runtime.
 */
export const EMPTY_OFFER_FORM_DATA: OfferFormData = {
  id: "",
  coachId: "",
  username: "",
  type: OfferType.Standard,

  summitId: null,
  summitSessionId: null,
  platformFeeBps: null,

  directSaleEnabled: null,
  price: null,
  currency: null,
  originalPrice: null,

  preHeadline: null,
  headline: null,
  description: null,

  vslVideoUrl: null,
  durationLabel: null,
  heroEyebrow: null,
  sprintTakeaway: null,

  strugglesHeadline: null,
  strugglesDescription: null,
  strugglesImageUrl: null,

  resultsPreHeadline: null,
  resultsHeadline: null,
  resultsDescription: null,
  resultsImageUrl: null,

  programHeadline: null,
  programDescription: null,
  programImageUrl: null,

  bottomCtaHeadline: null,
  bottomCtaText: null,

  applicationDeadline: null,
  cohortStartDate: null,

  satisfactionGuaranteeText: null,

  tags: [],
  benefits: [],
  testimonials: [],
  components: [],
  bonuses: [],
  faqs: [],
  curriculum: [],
};

export const offerFormOptions = formOptions({
  defaultValues: EMPTY_OFFER_FORM_DATA,
});
